import { ConversationApiState } from "../../Models/ConversationApiState";
import {
  ADD_RECENT_CONVERSATION_STATE,
  FETCH_ARCHIEVE_CONVERSATION_FAILURE,
  FETCH_ARCHIEVE_CONVERSATION_REQUEST,
  FETCH_ARCHIEVE_CONVERSATION_SUCCESS,
  FETCH_RECENT_CONVERSATION_FAILURE,
  FETCH_RECENT_CONVERSATION_REQUEST,
  FETCH_RECENT_CONVERSATION_SUCCESS,
  MARK_ARCHIEVE_CONVERSATION_AS_RECENT_SUCCESS,
  MARK_RECENT_CONVERSATION_AS_ARCHIEVE_SUCCESS,
  UPDATE_ARCHIEVE_CONVERSATION_TITLE_SUCCESS,
  UPDATE_CONVERSATION_TITLE_FAILURE,
  UPDATE_CONVERSATION_TITLE_REQUEST,
  UPDATE_CONVERSATION_UPDATEDDATE,
  UPDATE_RECENT_CONVERSATION_IF_NOT_AVAILABLE,
  UPDATE_RECENT_CONVERSATION_TITLE_SUCCESS,
} from "./ConverasationType";

const initialState: ConversationApiState = {
  loading: false,
  recentConversationLoading: true,
  recentConversation: [],
  archieveConversation: [],
  error: "",
};

const ConversationReducer = (state = initialState, action: any): ConversationApiState => {
  switch (action.type) {
    case FETCH_ARCHIEVE_CONVERSATION_REQUEST:
      return { ...state, loading: true };
    case FETCH_ARCHIEVE_CONVERSATION_SUCCESS:
      return { ...state, loading: false, archieveConversation: action.payload, error: "" };
    case FETCH_ARCHIEVE_CONVERSATION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_RECENT_CONVERSATION_REQUEST:
      return { ...state, recentConversationLoading: true };
    case FETCH_RECENT_CONVERSATION_SUCCESS:
      return { ...state, recentConversationLoading: false, recentConversation: action.payload, error: "" };
    case FETCH_RECENT_CONVERSATION_FAILURE:
      return { ...state, recentConversationLoading: false, error: action.payload };
    case MARK_RECENT_CONVERSATION_AS_ARCHIEVE_SUCCESS:
      const selectedRecentConversation = state.recentConversation.find((conversation) => conversation.id === action.payload);
      if (!selectedRecentConversation) return state;

      return {
        ...state,
        recentConversation: state.recentConversation.filter((conversation) => conversation.id !== action.payload),
        archieveConversation: [...state.archieveConversation, { ...selectedRecentConversation, isArchived: true }],
      };
    case MARK_ARCHIEVE_CONVERSATION_AS_RECENT_SUCCESS:
      const selectedArchiveConversation = state.archieveConversation.find((conversation) => conversation.id === action.payload);

      if (!selectedArchiveConversation) return state;

      return {
        ...state,
        recentConversation: [...state.recentConversation, { ...selectedArchiveConversation, isArchived: false }],
        archieveConversation: state.archieveConversation.filter((conversation) => conversation.id !== action.payload),
      };
    case ADD_RECENT_CONVERSATION_STATE:
      return { ...state, recentConversation: [...state.recentConversation, { ...action.payload }] };
    case UPDATE_CONVERSATION_TITLE_REQUEST:
      return { ...state };
    case UPDATE_RECENT_CONVERSATION_TITLE_SUCCESS:
      return { ...state, recentConversation: state.recentConversation.map((con) => (con.id === action.payload.id ? action.payload : con)) };
    case UPDATE_ARCHIEVE_CONVERSATION_TITLE_SUCCESS:
      return { ...state, archieveConversation: state.archieveConversation.map((con) => (con.id === action.payload.id ? action.payload : con)) };
    case UPDATE_CONVERSATION_TITLE_FAILURE:
      return { ...state, recentConversation: [...state.recentConversation, { ...action.payload }] };
    case UPDATE_CONVERSATION_UPDATEDDATE:
      return {
        ...state,
        recentConversation: state.recentConversation.map((con) =>
          con.id === action.payload ? { ...con, updateDate: new Date().toISOString() } : con
        ),
        archieveConversation: state.archieveConversation.map((con) =>
          con.id === action.payload ? { ...con, updateDate: new Date().toISOString() } : con
        ),
      };
    case UPDATE_RECENT_CONVERSATION_IF_NOT_AVAILABLE:
      // Check if conversation exists in archived conversations
      const existingArchivedConversation = state.archieveConversation.find(
        (con) => con.id === action.payload.id
      );

      // If conversation exists in archived, don't process it
      if (existingArchivedConversation) {
        // Check if payload date is more recent than the existing date
        const existingDate = new Date(existingArchivedConversation.updateDate);
        const payloadDate = new Date(action.payload.updateDate);

        // Only update if the payload date is greater (more recent) than existing date
        if (payloadDate > existingDate) {
          return {
            ...state,
            archieveConversation: state.archieveConversation.map((con) =>
              con.id === action.payload.id
                ? { ...con, updateDate: action.payload.updateDate }
                : con
            )
          };
        }

        return state;
      }
      // Check if conversation exists in recent conversations
      const existingConversation = state.recentConversation.find(
        (con) => con.id === action.payload.id
      );

      // If conversation already exists in the recent list, keep it as is without updating
      if (existingConversation) {
        // Check if payload date is more recent than the existing date
        const existingDate = new Date(existingConversation.updateDate);
        const payloadDate = new Date(action.payload.updateDate);

        // Only update if the payload date is greater (more recent) than existing date
        if (payloadDate > existingDate) {
          return {
            ...state,
            recentConversation: state.recentConversation.map((con) =>
              con.id === action.payload.id
                ? { ...con, updateDate: action.payload.updateDate }
                : con
            )
          };
        }

        // If dates match, keep state as is
        return state;
      }

      // If conversation doesn't exist, append it to recentConversation
      return {
        ...state,
        recentConversation: [...state.recentConversation, {
          ...action.payload,
          updateDate: new Date().toISOString()
        }]
      };
    default:
      return state;
  }
};

export default ConversationReducer;
